import { JourneysLegacyRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/accept-guest-invitation/$')({
  component: JourneysLegacyRoute,
});
